import 'react';
import PropTypes from '../../../node_modules/prop-types/index.js';

// TODO: Will be removed in v4
var SideNavSection = function SideNavSection(_ref) {
  var children = _ref.children;
  return children;
};
SideNavSection.propTypes = {
  children: PropTypes.node.isRequired
};
process.env.NODE_ENV !== "production" ? SideNavSection.displayName = 'SideNavSection' : void 0;
var SideNavSection$1 = SideNavSection;

export { SideNavSection$1 as default };
